import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PublicHeader from "@/components/layout/PublicHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(t("auth.checkInbox"));
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };
  return (
    <div data-testid="forgot-page" className="min-h-screen bg-background">
      <PublicHeader />
      <section className="max-w-md mx-auto px-6 py-16">
        <div className="overline text-primary mb-3">{t("auth.forgotTitle").toUpperCase()}</div>
        <h1 className="font-heading text-4xl font-extrabold tracking-tight text-secondary leading-tight">{t("auth.forgotTitle")}</h1>
        <p className="mt-2 text-muted-foreground">{t("auth.forgotSub")}</p>
        {sent ? (
          <div className="mt-8 p-6 border border-border rounded-lg bg-white" data-testid="forgot-success">
            <p className="text-sm text-muted-foreground">{t("auth.checkInbox")}</p>
            <Link to="/login" data-testid="back-to-login" className="text-primary hover:underline text-sm mt-3 inline-block">← {t("auth.backToLogin")}</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
            <div><Label htmlFor="email">{t("auth.email")}</Label><Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
            <Button data-testid="forgot-submit" disabled={busy} type="submit" className="w-full h-11">{busy ? t("auth.sending") : t("auth.sendLink")}</Button>
            <div className="text-center"><Link to="/login" className="text-sm text-muted-foreground hover:text-primary">{t("auth.backToLogin")}</Link></div>
          </form>
        )}
      </section>
    </div>
  );
}
